export default __webpack_public_path__ + "static/media/oulined-logo.1e386236.svg";